import { ButtonType, ButtonWidget } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';

import { Domain } from '../types/Domain';
import { PoolID } from '../types/PoolID';
import { UserDefinedPoolModel } from '../types/PoolModel';
import { openAddPoolDomainDialog } from './addNewDomainDialog/AddNewDomainDialog';


export type AddPoolDomainButtonProps = Readonly<{
  siteId: string;
  poolId: PoolID;
  poolName: string;
  userDefinedPools: Record<string, UserDefinedPoolModel>;
  bridgeDomains: Record<string, Domain>;
  refreshPoolsAndClusters: () => void;
}>;

export function AddPoolDomainButton(props: AddPoolDomainButtonProps) {
  return <>
    {renderAddPoolDomainButton(props)}
  </>;
}


function renderAddPoolDomainButton(props: AddPoolDomainButtonProps) {
  const addPoolDomainAction = ()=>{
    openAddPoolDomainDialog(props.poolId as PoolID, props.poolName, props.siteId, props.userDefinedPools, props.bridgeDomains, props.refreshPoolsAndClusters);
  };

  return (
    <span className={'tb-data-grid-icon tb-padded-left-small' + buttonPaddingLeftClass} data-tb-test-id={'add-pool-domain-cell'}>
      <ButtonWidget
        testId={'add-pool-domain'} buttonType={ButtonType.Outline}
        onClick={addPoolDomainAction}
        style={{marginRight: 10, paddingRight:5,  paddingLeft:5, borderColor: 'transparent'}}
      >
        <span className={inlineBlockClass}>
          <img className={verticalAlignClass} src={imgPath('plus_14px-small.svg')} alt={''} />
          <span className={textPaddingLeftClass}>
            {Messages.dataConnectSiteSettingsAddNewDomainButton()}
          </span>
        </span>
      </ButtonWidget>
    </span>
  );
}

export const inlineBlockClass = style({
  display: 'inline-block',
});
export const verticalAlignClass = style({
  verticalAlign: 'middle'
});
export const textPaddingLeftClass = style({
  paddingLeft: 2
});

export const buttonPaddingLeftClass = style({
  paddingLeft: 10
});

